/**
 * Componente Stat - linha label/valor usada nos cards de KPI do wizard.
 *
 * RELEASE: 2026-05-16 v1.0.0
 */

interface StatProps {
  label: string;
  value: number;
  variant?: 'success' | 'warning' | 'destructive';
}

export function Stat({ label, value, variant }: StatProps) {
  // Cor semântica baseada no tipo de métrica exibida.
  const colorClass =
    variant === 'success' ? 'text-green-600 dark:text-green-400' :
    variant === 'warning' ? 'text-amber-600 dark:text-amber-400' :
    variant === 'destructive' ? 'text-destructive' : '';

  return (
    <div className="flex justify-between">
      <span className="text-muted-foreground">{label}</span>
      <span className={`font-semibold ${colorClass}`}>
        {value.toLocaleString('pt-BR')}
      </span>
    </div>
  );
}
